import { Box, FormControl, TextField, Typography, useMediaQuery, useTheme } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import React, { useState } from 'react';

interface IDateInputProps {
  dateSearch: string;
  onChange: (dateSearch: string) => void;
}

export const DateInput: React.FC<IDateInputProps> = ({ dateSearch, onChange }) => {
  const theme = useTheme();

  const [openCalendar, setOpenCalendar] = useState<boolean>(false);
  const isXsScreen = useMediaQuery(theme.breakpoints.down('md'));

  const handleChange = (date: string) => {
    onChange(date || '');
    setOpenCalendar(false);
  };

  return (
    <Box>
      <FormControl>
        <Typography sx={{ color: 'text.primary', fontWeight: '600', textAlign: 'left' }} gutterBottom>
          Data
        </Typography>
        <LocalizationProvider dateAdapter={AdapterDayjs} localeText={{ clearButtonLabel: 'Limpar', todayButtonLabel: 'Hoje' }}>
          <DatePicker
            value={dateSearch}
            onChange={handleChange}
            onClose={() => setOpenCalendar(false)}
            renderInput={params => (
              <TextField
                {...params}
                required={false}
                size="small"
                onKeyDown={e => {
                  e.preventDefault();
                }}
                onTouchStart={() => setOpenCalendar(prev => !prev)}
                onClick={() => {
                  setOpenCalendar(prev => !prev);
                }}
                InputProps={{
                  ...params.InputProps,
                  style: { width: isXsScreen ? '120px' : '190px', height: '40px' },
                }}
              />
            )}
            inputFormat="DD/MM/YYYY"
            open={openCalendar}
            componentsProps={{
              actionBar: {
                actions: ['clear', 'accept'],
                onClick: () => setOpenCalendar(prev => !prev),
              },
            }}
          />
        </LocalizationProvider>
      </FormControl>
    </Box>
  );
};
